import React from "react";

export default function TbBrandTiktok() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#n)">
        <path
          d="M13.5.082h2.97c.216 1.073.81 2.426 1.853 3.768 1.02 1.316 2.372 2.232 4.177 2.232v3c-2.63 0-4.605-1.221-6-2.743v10.243a7.5 7.5 0 1 1-7.5-7.5v3a4.5 4.5 0 1 0 4.5 4.5V.082Z"
          fill="#currentColor"
        />
      </g>
      <defs>
        <clipPath id="n">
          <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
